import type { FC } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

import { iconMap } from '@/utils/iconRegistry';

export interface IconProps extends Omit<SvgIconProps, 'component'> {
    name: keyof typeof iconMap;
    size?: string | number;
    disabled?: boolean;
    color?: string;
}

export const AppIcon: FC<IconProps> = ({ name, size, disabled, color, ...props }) => {
    const SvgComponent = iconMap[name];

    if (!SvgComponent) {
        console.warn(`[Icon]: Not found "${name}".`);

        return null;
    }

    return (
        <SvgIcon
            inheritViewBox
            component={SvgComponent}
            color='inherit'
            sx={{
                fontSize: size,
                opacity: disabled ? 0.4 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                transition: 'opacity 0.2s',
                color,
            }}
            {...props}
        />
    );
};
